import DuelBreakdownBannerJpg from './breakdown-banner.jpg';
import DuelCalendarPng from './calendar.png';
import DuelCashJpg from './cash.jpg';
import DuelChipStackPng from './chip-stack.png';
import DuelChipsJpg from './chips.jpg';
import DuelCompleteTrophyJpg from './complete-trophy.jpg';
import DuelCrownMedallionPng from './crown-medallion.png';
import DuelTypeMegaPng from './duel-type-mega.png';
import DuelTypeRankedPng from './duel-type-ranked.png';
import DuelTypeSpecialPng from './duel-type-special.png';
import DuelFeatureSamePng from './feature-same.png';
import DuelGiftJpg from './gift.jpg';
import DuelGiftBoxPng from './gift-box.png';
import DuelHeroSwordsJpg from './hero-swords.jpg';
import DuelHistoryJpg from './history.jpg';
import DuelHudChevronLeftSvg from './hud/hud-chevron-left.svg';
import DuelHudChevronRightSvg from './hud/hud-chevron-right.svg';
import DuelHudClockPng from './hud/hud-clock.png';
import DuelHudFinishedFlagSvg from './hud/hud-finished-flag.svg';
import DuelHudHistorySvg from './hud/hud-history.svg';
import DuelHudInfoSvg from './hud/hud-info.svg';
import DuelHudLeaveSvg from './hud/hud-leave.svg';
import DuelHudLiveDotSvg from './hud/hud-live-dot.svg';
import DuelHudMorePng from './hud/hud-more.png';
import DuelHudPeoplePng from './hud/hud-people.png';
import DuelHudRailShellSvg from './hud/hud-rail-shell.svg';
import DuelHudSheetShellSvg from './hud/hud-sheet-shell.svg';
import DuelHudShieldPng from './hud/hud-shield.png';
import DuelHudTrophyPng from './hud/hud-trophy.png';
import DuelResultChartSvg from './hud/result-chart.svg';
import DuelResultClockPng from './hud/result-clock.png';
import DuelResultCrownPng from './hud/result-crown.png';
import DuelResultDecisionPng from './hud/result-decision.png';
import DuelResultEfficiencyPng from './hud/result-efficiency.png';
import DuelResultHomeSvg from './hud/result-home.svg';
import DuelResultOutcomePng from './hud/result-outcome.png';
import DuelResultPlayerPng from './hud/result-player.png';
import DuelResultRatingPng from './hud/result-rating.png';
import DuelResultSeasonPng from './hud/result-season.png';
import DuelResultShieldSwordsPng from './hud/result-shield-swords.png';
import DuelResultSparkleSvg from './hud/result-sparkle.svg';
import DuelResultSparkle2Svg from './hud/result-sparkle-2.svg';
import DuelResultSparkle3Svg from './hud/result-sparkle-3.svg';
import DuelResultTrophyPng from './hud/result-trophy.png';
import DuelIconCardsSvg from './icon-cards.svg';
import DuelIconChevronSvg from './icon-chevron.svg';
import DuelIconClockSvg from './icon-clock.svg';
import DuelIconCrownSvg from './icon-crown.svg';
import DuelIconEmailPng from './icon-email.png';
import DuelIconLockSvg from './icon-lock.svg';
import DuelIconPersonSvg from './icon-person.svg';
import DuelIconPlayersSvg from './icon-players.svg';
import DuelIconRequestIdPng from './icon-request-id.png';
import DuelIconSwordsSvg from './icon-swords.svg';
import DuelMissionTargetPng from './mission-target.png';
import DuelNodeCheckSvg from './node-check.svg';
import DuelPayPalPng from './paypal.png';
import DuelRatingShieldPng from './rating-shield.png';
import DuelRealMoneyPng from './real-money.png';
import DuelRealWorldRewardPng from './real-world-reward.png';
import DuelRequestSubmittedBgPng from './request-submitted-bg.png';
import DuelRewardBannerBgPng from './reward-banner-bg.png';
import DuelScoreCardsSvg from './score-cards.svg';
import DuelScoreFlameSvg from './score-flame.svg';
import DuelScoreShieldPng from './score-shield.png';
import DuelScoreStarSvg from './score-star.svg';
import DuelSeasonBannerJpg from './season-banner.jpg';
import DuelSeasonGiftPng from './season-gift.png';
import DuelSeasonTrophyPng from './season-trophy.png';
import DuelSettledBannerJpg from './settled-banner.jpg';
import DuelShieldJpg from './shield.jpg';
import DuelStarPng from './star.png';
import DuelSuccessCheckPng from './success-check.png';
import DuelSuccessConfettiPng from './success-confetti.png';
import DuelSuccessGlowPng from './success-glow.png';
import DuelSwordsPng from './swords.png';
import DuelTrophyPng from './trophy.png';
import DuelVoucherPng from './voucher.png';
import DuelXpJpg from './xp.jpg';
export {
	DuelHudMorePng,
	DuelResultChartSvg,
	DuelResultClockPng,
	DuelResultCrownPng,
	DuelResultDecisionPng,
	DuelResultEfficiencyPng,
	DuelResultHomeSvg,
	DuelResultOutcomePng,
	DuelResultPlayerPng,
	DuelResultRatingPng,
	DuelResultSeasonPng,
	DuelResultShieldSwordsPng,
	DuelResultSparkle2Svg,
	DuelResultSparkle3Svg,
	DuelResultSparkleSvg,
	DuelResultTrophyPng,
	DuelHudChevronLeftSvg,
	DuelHudChevronRightSvg,
	DuelHudClockPng,
	DuelHudFinishedFlagSvg,
	DuelHudHistorySvg,
	DuelHudInfoSvg,
	DuelHudLeaveSvg,
	DuelHudLiveDotSvg,
	DuelHudPeoplePng,
	DuelHudRailShellSvg,
	DuelHudSheetShellSvg,
	DuelHudShieldPng,
	DuelHudTrophyPng,
	DuelSuccessConfettiPng,
	DuelSuccessGlowPng,
	DuelTypeMegaPng,
	DuelTypeSpecialPng,
	DuelIconEmailPng,
	DuelIconRequestIdPng,
	DuelPayPalPng,
	DuelRealWorldRewardPng,
	DuelRequestSubmittedBgPng,
	DuelRewardBannerBgPng,
	DuelSuccessCheckPng,
	DuelVoucherPng,
	DuelMissionTargetPng,
	DuelRealMoneyPng,
	DuelSeasonBannerJpg,
	DuelTypeRankedPng,
	DuelBreakdownBannerJpg,
	DuelCalendarPng,
	DuelCashJpg,
	DuelChipStackPng,
	DuelChipsJpg,
	DuelCompleteTrophyJpg,
	DuelCrownMedallionPng,
	DuelFeatureSamePng,
	DuelGiftBoxPng,
	DuelGiftJpg,
	DuelHeroSwordsJpg,
	DuelHistoryJpg,
	DuelIconCardsSvg,
	DuelIconChevronSvg,
	DuelIconClockSvg,
	DuelIconCrownSvg,
	DuelIconLockSvg,
	DuelIconPersonSvg,
	DuelIconPlayersSvg,
	DuelIconSwordsSvg,
	DuelNodeCheckSvg,
	DuelRatingShieldPng,
	DuelScoreCardsSvg,
	DuelScoreFlameSvg,
	DuelScoreShieldPng,
	DuelScoreStarSvg,
	DuelSeasonGiftPng,
	DuelSeasonTrophyPng,
	DuelSettledBannerJpg,
	DuelShieldJpg,
	DuelStarPng,
	DuelSwordsPng,
	DuelTrophyPng,
	DuelXpJpg,
};
